/**
 * Page hero header.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @copyright 2024 Simon Lagerlöf
 * @since 1.0.0
 */

import shrinkTextToFit from '../utils/shrink-text-to-fit';

export default function hero(): void {
  const hero = document.querySelector<HTMLElement>(
    'header.page-hero',
  );
  const title = hero?.querySelector<HTMLHeadingElement>(
    'h1.page-hero__title',
  );

  if (!hero || !title) {
    return;
  }

  const observer = new ResizeObserver(() =>
    shrinkTextToFit(hero, title),
  );

  observer.observe(document.body);

  shrinkTextToFit(hero, title);
}
